export const SURVEY_TYPE_DISPLAY = {
  standard: 'Survey',
  onboarding: 'Onboarding Survey',
  exit: 'Exit Survey',
};
